import { IconButton } from "@remo-co/ui-core/src/components/IconButton";
import { Modal } from "@remo-co/ui-core/src/components/Modal";
import { Close as CloseIcon } from "@remo-co/ui-core/src/icons/Close";
import { useStyles } from "./EventImagePopup.styles";

interface IEventImagePopupProps {
  src?: string;
  onClose: () => void;
}

const EventImagePopup = ({ src, onClose }: IEventImagePopupProps) => {
  const styles = useStyles();

  return (
    <Modal open className={styles.eventImagePopupContainer}>
      <>
        <img src={src} alt="Event Popup" className={styles.image} />
        <IconButton
          size="small"
          onClick={onClose}
          className={styles.closeButton}
          data-testid="event-image-popup-close"
        >
          <CloseIcon />
        </IconButton>
      </>
    </Modal>
  );
};

export default EventImagePopup;
